"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPaymentRequest = void 0;
var ProductPaymentRequest = /** @class */ (function () {
    function ProductPaymentRequest() {
    }
    return ProductPaymentRequest;
}());
exports.ProductPaymentRequest = ProductPaymentRequest;
;
//# sourceMappingURL=productPayment.request.js.map